import type { FecAccountMapping } from '../types/fecAccountMapping'

export const dedupeFecAccountMappings = (mappings: FecAccountMapping[]): FecAccountMapping[] => {
  const seenAccountNos = new Set<string>()
  const result: FecAccountMapping[] = []

  for (const mapping of mappings) {
    if (seenAccountNos.has(mapping.accountNo)) {
      continue
    }

    seenAccountNos.add(mapping.accountNo)
    result.push(mapping)
  }

  return result
}
